export const messages = {
  en: {
    myAuditHistoryComplaints: {
      title: 'Complaint History Orders',
      complaintId: 'Complaint ID',
      typeCdName: 'Complaint Type',
      room: 'Room',
      building: 'Building ',
      unit: 'Unit ',
      complaintName: 'Complainant',
      tel: 'Complaint Phone',
      stateName: 'Complaint Status',
      operation: 'Operation',
      detail: 'Detail'
    },
    complaintDetail: {
      detail: ' Detail',
      roomInfo: 'Room Information',
      complaintCode: 'Complaint Code',
      complaintType: 'Complaint Type',
      complaintName: 'Complainant',
      complaintTel: 'Complaint Phone',
      complaintStatus: 'Complaint Status',
      processor: 'Processor',
      processorTel: 'Processor Phone',
      processorId: 'Processor ID',
      complaintContent: 'Complaint Content',
      complaintPhotos: 'Complaint Photos',
      serialNumber: 'No.',
      status: 'Status',
      processTime: 'Process Time',
      timeConsuming: 'Time Consuming',
      opinion: 'Opinion',
      none: 'None'
    },
    common: {
      close: 'Close'
    }
  },
  zh: {
    myAuditHistoryComplaints: {
      title: '投诉历史单',
      complaintId: '投诉ID',
      typeCdName: '投诉类型',
      room: '房屋',
      building: '号楼',
      unit: '单元',
      complaintName: '投诉人',
      tel: '投诉电话',
      stateName: '投诉状态',
      operation: '操作',
      detail: '详情'
    },
    complaintDetail: {
      detail: '详情',
      roomInfo: '房屋信息',
      complaintCode: '投诉编码',
      complaintType: '投诉类型',
      complaintName: '投诉人',
      complaintTel: '投诉人电话',
      complaintStatus: '投诉状态',
      processor: '处理人',
      processorTel: '处理人电话',
      processorId: '处理人编号',
      complaintContent: '投诉内容',
      complaintPhotos: '投诉图片',
      serialNumber: '序号',
      status: '状态',
      processTime: '处理时间',
      timeConsuming: '耗时',
      opinion: '意见',
      none: '无'
    },
    common: {
      close: '关闭'
    }
  }
}